// extracted by mini-css-extract-plugin
export default {"outer":"stylesMutual_outer__MyzcJ"};